// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"loader_ldsEllipsis__pYEdl","ldsEllipsis1":"loader_ldsEllipsis1__7rjqg","ldsEllipsis2":"loader_ldsEllipsis2__1VWR7","ldsEllipsis3":"loader_ldsEllipsis3__RxaXm"};